/**
 * @ngdoc component
 * @name  common.newsletter.component:NewsletterSections
 * @description
 * Show sections in newsletter form.
 * 
 */
 (function() {

    'use strict';

    var NewsletterSectionsCmp = {
        templateUrl: 'NewsletterSectionsCmp.html',
        controller: NewsletterSectionsCmpCtrl,
        controllerAs: '$ctrl',
        bindings: {
            sectionsSelected: '='
        }
    };
    angular.module('itxApp.common').component('newsletterSections', NewsletterSectionsCmp);

    NewsletterSectionsCmpCtrl.$inject = ['ItxNewsletterSvc', 'ItxTranslateSvc', '$scope'];

    function NewsletterSectionsCmpCtrl(ItxNewsletterSvc, ItxTranslateSvc, $scope) {
        var _this = this;
        _this.sections = [];

        function Checkbox(title, name, checked) {
            this.type = 'check';
            this.title = title;
            this.checked = checked || false;
            this.name = name;
        }

        _this.$onInit = function() {
            if(!_this.sectionsSelected){
                _this.sectionsSelected = [];
            }

            ItxTranslateSvc.waitTranslations().then(() => {
                var sections = ItxNewsletterSvc.getConfiguration();

                for (var i = 0; i < sections.length; ++i) {
                    _this.sections.push(
                        new Checkbox(
                            sections[i].description,
                            sections[i].name,
                            _this.sectionsSelected.indexOf(sections[i].name) !== -1
                        )
                    );
                }
                $scope.$applyAsync();
            });

            /*   _this.women = new Checkbox('store.section.1', 'WOMEN', _this.sectionsSelected.indexOf('WOMEN') !== -1);
            _this.men = new Checkbox('store.section.2', 'MEN',_this.sectionsSelected.indexOf('MEN') !== -1);
            _this.boysGirls = new Checkbox('store.section.3', 'B&G',_this.sectionsSelected.indexOf('B&G') !== -1);
            _this.tailoring = new Checkbox('store.section.4', 'PERSONAL TAILORING',_this.sectionsSelected.indexOf('PERSONAL TAILORING') !== -1);*/
        };

        /**
         * @ngdoc method
         * @name isSectionSelected
         * @private
         * @methodOf  common.newsletter.component:NewsletterSections
         * @description
         * Check if given section has been already selected.
         * @param {string} section - Section name
         * @return {boolean} - selected
         */
        _this.isSectionSelected = function(section) {
            return _.findIndex(_this.sectionsSelected, function(elem) {
                return elem == section;
            }) !== -1;
        };
        /**
         * @ngdoc method
         * @name addSection
         * @methodOf  common.newsletter.component:NewsletterSections
         * @description
         * Add section to the array of selected sections if was not previuosly selected. Otherwise, remove it
         * from array.
         */
        _this.addSection = function(section) {
            if (_this.isSectionSelected(section)) {
                _this.sectionsSelected = _.without(_this.sectionsSelected, section);
            } else {
                _this.sectionsSelected.push(section);
            }
        };
    }
})();
